import { createFileRoute } from '@tanstack/react-router'
import { BulkIdoneitaUploadPage } from '@/features/documents/bulk-idoneity'

export const Route = createFileRoute('/documents_/bulk-idoneita')({
  component: BulkIdoneitaUploadPage,
})
